import { Dialog } from 'primereact/dialog';
import React, { type FC } from 'react';

export type DecisionMakingWantedStatusModalProps = {
  isOpen: boolean;
  setModalOpen: (boolean) => void;
};

const DecisionMakingWantedStatusModal: FC<DecisionMakingWantedStatusModalProps> = ({
  isOpen,
  setModalOpen,
}) => {
  return (
    <Dialog header="Header" visible={isOpen} style={{ width: '50vw' }} onHide={() => { if (!isOpen) return; setModalOpen(false); }}>
      <p className="m-0">
        you can only store wanted properties in this list. Would you like to change the status of this property?

      </p>
    </Dialog>
  );
};

export default DecisionMakingWantedStatusModal;
